import React from 'react'
import { usePageView } from 'hooks'
import { getStaticWrapper } from 'utils'
import PartnershipsLayout from 'components/PartnershipsSite/PartnershipsLayout'
import SponsorshipSecondary from 'components/PartnershipsSite/SponsorshipSecondary'
import VideoSection from 'components/PartnershipsSite/VideoSection'
import PhotoQuote from 'components/PartnershipsSite/PhotoQuote'
import { MediaStore } from 'stores/media'

const IntegrationBottom = ({ hostRead, brandedSegment, studioShow }) => {
  const videoSections = [
    {
      header: 'Host Read',
      subheader: 'Host-read ad reads across audio, video and social',
      videos: [
        {
          videoSource: hostRead[0],
          text: 'Podcast Show Example'
        },
        {
          videoSource: hostRead[1],
          text: 'Social Series Example'
        },
        {
          videoSource: hostRead[2],
          text: 'Behind-the-Scenes Show Example'
        }
      ],
      brands: [
        'https://chumley.barstoolsports.com/union/2021/02/02/barstool_icon.85479689.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/youtube.a2d3c064.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/spotify.7c216f33.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/roku.4d22a0e3.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/fire_tv.dfba198e.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/apple_tv.6b267990.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/itunes.1216ff34.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/pandora.eae8d2d3.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/android_tv.35747ab3.png'
      ]
    },
    {
      header: 'Branded Segment',
      subheader: "Ownership of a show's recurring segment to further align brand messaging with a Barstool franchise",
      videos: [
        {
          videoSource: brandedSegment[0],
          text: 'Studio Show Example'
        },
        {
          videoSource: brandedSegment[1],
          text: 'Podcast Show Example'
        },
        {
          videoSource: brandedSegment[2],
          text: 'Snap Show Example'
        }
      ],
      brands: [
        'https://chumley.barstoolsports.com/union/2021/02/02/barstool_icon.85479689.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/youtube.a2d3c064.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/spotify.7c216f33.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/roku.4d22a0e3.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/fire_tv.dfba198e.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/apple_tv.6b267990.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/instagram.291749e7.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/facebook.384e7f8d.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/itunes.1216ff34.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/pandora.eae8d2d3.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/android_tv.35747ab3.png'
      ]
    },
    {
      header: 'Studio/Show Sponsorship',
      subheader:
        'Ownership of a Barstool Show that integrates the brand in-studio and across every single piece of content in audio, video and social',
      videos: [
        {
          videoSource: studioShow[0],
          text: 'Podcast Show Example'
        },
        {
          videoSource: studioShow[1],
          text: 'Studio Show Example'
        }
      ],
      brands: [
        'https://chumley.barstoolsports.com/union/2021/02/02/barstool_icon.85479689.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/youtube.a2d3c064.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/spotify.7c216f33.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/roku.4d22a0e3.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/fire_tv.dfba198e.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/apple_tv.6b267990.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/instagram.291749e7.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/facebook.384e7f8d.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/itunes.1216ff34.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/pandora.eae8d2d3.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/android_tv.35747ab3.png'
      ]
    },
    {
      header: 'Product Integration',
      subheader:
        'On-set product integration is included in all sponsorships and is available at a premium for branded segment and host read ad products',
      videos: [
        {
          img: 'https://chumley.barstoolsports.com/union/2021/05/26/coors-light-podcast-show-product.c6e27f9b.png?crop=0.90%2C0.99%2Cx0.04%2Cy0.00%2Csafe',
          text: 'Podcast Show Example'
        },
        {
          img: 'https://chumley.barstoolsports.com/union/2021/05/26/go-puff-livestream-product.1c023008.png',
          text: 'Livestream Example'
        },
        {
          img: 'https://chumley.barstoolsports.com/union/2021/05/26/hooters-sportsbook-house-product.934eb639.png',
          text: 'Livestream Example'
        }
      ],
      brands: [
        'https://chumley.barstoolsports.com/union/2021/02/02/barstool_icon.85479689.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/youtube.a2d3c064.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/spotify.7c216f33.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/roku.4d22a0e3.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/fire_tv.dfba198e.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/apple_tv.6b267990.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/instagram.291749e7.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/facebook.384e7f8d.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/itunes.1216ff34.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/pandora.eae8d2d3.png',
        'https://chumley.barstoolsports.com/union/2021/02/02/android_tv.35747ab3.png'
      ]
    }
  ]

  return (
    <div className='integrationBottom'>
      {videoSections.map((sectionProps, idx) => (
        <VideoSection key={idx} {...sectionProps} />
      ))}
    </div>
  )
}

const SponsorshipIntegration = ({ hostRead, brandedSegment, studioShow }) => {
  usePageView()

  return (
    <PartnershipsLayout background='#D8D8D8'>
      <SponsorshipSecondary
        title={'PREMIUM INTEGRATION'}
        details={
          'Integrate your brand into the most creative and authentic original content network spanning across audio, video and social'
        }
        top={
          <PhotoQuote
            img={'https://chumley.barstoolsports.com/union/2021/06/08/Premium-Integration-Blue.33ebc76a.png'}
            text={[
              'WE BRING CREATIVITY TO OUR PARTNERS',
              'We deliver the highest performing ad products - marrying the power of host-read endorsements with authentic, branded content.'
            ]}
          />
        }
        bottom={
          hostRead.length || brandedSegment.length || studioShow.length ? (
            <IntegrationBottom hostRead={hostRead} brandedSegment={brandedSegment} studioShow={studioShow} />
          ) : null
        }
        centerSectionBreak
      />
    </PartnershipsLayout>
  )
}

export const getStaticProps = getStaticWrapper(async () => {
  try {
    const hostRead = await Promise.all([
      await MediaStore().findById('eczcQg93Csfr7t5aiyKGxQ'),
      await MediaStore().findById('kVJNK2zdYpjLhDJphzaTGx'),
      await MediaStore().findById('wUXXn35GHr8Pn9FQFxEb3q')
    ])

    const brandedSegment = await Promise.all([
      await MediaStore().findById('5zcALqAw4aTCQxucZ4zzxi'),
      await MediaStore().findById('mRYQGMEeLw5XZM7j4LcNV9'),
      await MediaStore().findById('424rCHKF29YS16sQCaxiCf')
    ])

    const studioShow = await Promise.all([
      await MediaStore().findById('wyW3ha3qYT8mTgps5nEkkJ'),
      await MediaStore().findById('wZTJNZbgaUVpPgcc83qspB')
    ])

    return { hostRead, brandedSegment, studioShow }
  } catch (e) {
    return { hostRead: false, brandedSegment: false, studioShow: false }
  }
})

export default SponsorshipIntegration
